import * as React from "react"
import { ImageBlockProps } from "./image_block"
import { List } from "immutable"

export interface ImagesBlockProps {
  readonly images: List<ImageBlockProps>
}

export const ImagesBlock: React.StatelessComponent<ImagesBlockProps> = p => (
  <section className="block block--image-grid container--lg align--center">
    <ul className="row block__list">
      {p.images.map((i, k) => (
        <li className="block__item col-xs-12 col-sm-6 col-md-4" key={`images-${k}`}>
          <div className="image-block__wrapper">
            <div className="image-block__inner">
              <img
                src="/bkw/images/bkw/empty.png"
                data-src={i.imageUrl}
                data-srcset={`${i.imageUrlSmall} 400w, ${i.imageUrl} 800w`}
                width="400"
                height="280"
                alt={i.imageAlt}
                className="image-block__image lazyload"
              />
            </div>
          </div>
        </li>
      ))}
    </ul>
  </section>
)

{/* TH: Added to styleguide! */}

